import { Button, vars } from '@etg/wings';
import { useTranslation, useProperty } from '@eti/providers';
import { css, cx } from '@eti/styles';
import isFunction from 'lodash/isFunction';
import { useResultPageContext } from '../../v3/contexts/ResultPageContext';

const buttonsWrapperStyles = css`
  display: flex;
  flex: 1 0 100%;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
`;

const drawerBtnsWrapperStyles = css`
  flex-direction: column;
  padding: 16px;

  > button {
    border-radius: ${vars.card.borderRadius};
  }
`;

const resetButtonStyles = css`
  flex-grow: 1;
`;

const doneButtonStyles = css`
  flex-grow: 3;
`;

interface FiltersButtonsProps {
  className?: string;
  onClear?: () => void;
}

const FiltersButtons = ({ className, onClear }: FiltersButtonsProps) => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const { closeFiltersPanel, searchData } = useResultPageContext();
  const filteredFlightsCount = searchData?.filteredFlightsCount ?? 0;

  const handleDone = () => {
    if (isFunction(closeFiltersPanel)) {
      closeFiltersPanel();
    }
  };

  const handleClear = () => {
    if (isFunction(onClear)) {
      onClear();
    }
  };

  return (
    <div
      className={cx(
        buttonsWrapperStyles,
        p('Result.Page.V3.DesktopDrawerSearchResultFilters.Enabled') && drawerBtnsWrapperStyles,
        className,
      )}
    >
      <Button
        className={resetButtonStyles}
        data-testid="filtersForm-resetFilters-button"
        onClick={handleClear}
      >
        {t('Result.SearchFilters.ClearFilters.Button')}
      </Button>
      <Button
        className={doneButtonStyles}
        data-testid="filtersForm-applyFilters-button"
        onClick={handleDone}
        variant="primary"
      >
        {t('Result.SearchFilters.ShowFlights.Button', filteredFlightsCount)}
      </Button>
    </div>
  );
};

export default FiltersButtons;
